/**
 * 关于页 — 版本信息、开源致谢、官网链接
 * 对齐 features.md 9.23
 */

import { HUMP_DOC_VERSION } from '@hump/shared-types';

/** 应用版本：优先从构建期注入的环境变量读取，回退到硬编码默认值 */
const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.1.0';

const dependencies = [
  { name: 'React', license: 'MIT' },
  { name: 'Zustand', license: 'MIT' },
  { name: 'Vite', license: 'MIT' },
  { name: 'Tailwind CSS', license: 'MIT' },
  { name: 'pdfjs-dist', license: 'Apache-2.0' },
  { name: 'epubjs', license: 'BSD-2-Clause' },
  { name: 'markdown-it', license: 'MIT' },
  { name: 'KaTeX', license: 'MIT' },
  { name: 'lucide-react', license: 'ISC' },
  { name: 'react-router', license: 'MIT' },
  { name: 'i18next', license: 'MIT' },
  { name: 'Vitest', license: 'MIT' },
];

export function AboutPage() {
  return (
    <div className="space-y-6 max-w-md">
      {/* 品牌信息 */}
      <div className="text-center py-4">
        <p className="text-5xl mb-2">🐪</p>
        <h1 className="text-2xl font-serif text-camel-dark">Hump</h1>
        <p className="text-sm text-charcoal/50 dark:text-charcoal-light/50 mt-1">
          蓄满驼峰，读得更远。
        </p>
        <p className="text-xs text-charcoal/40 dark:text-charcoal-light/40 mt-2">
          Read farther.
        </p>
      </div>

      {/* 版本信息 */}
      <div className="p-4 rounded-lg bg-warm-white dark:bg-warm-dark">
        <div className="flex justify-between text-sm">
          <span className="text-charcoal/60 dark:text-charcoal-light/60">版本</span>
          <span className="text-charcoal dark:text-charcoal-light font-mono">{APP_VERSION}</span>
        </div>
        <div className="flex justify-between text-sm mt-2">
          <span className="text-charcoal/60 dark:text-charcoal-light/60">Hump Doc 格式</span>
          <span className="text-charcoal dark:text-charcoal-light font-mono">v{HUMP_DOC_VERSION}</span>
        </div>
      </div>

      {/* 开源致谢 */}
      <div>
        <h2 className="text-sm font-medium text-charcoal dark:text-charcoal-light mb-2">
          开源依赖
        </h2>
        <div className="space-y-1">
          {dependencies.map((dep) => (
            <div key={dep.name} className="flex justify-between text-xs">
              <span className="text-charcoal/70 dark:text-charcoal-light/70">{dep.name}</span>
              <span className="text-charcoal/40 dark:text-charcoal-light/40">{dep.license}</span>
            </div>
          ))}
        </div>
      </div>

      {/* 链接 */}
      <div className="pt-4 border-t border-border-warm dark:border-border-warm-dark">
        <a
          href="https://hump.2100laike.com"
          className="block text-sm text-camel hover:text-camel-dark"
        >
          官网 →
        </a>
      </div>

      <p className="text-xs text-charcoal/30 dark:text-charcoal-light/30 text-center">
        © 2026 Hump. All rights reserved.
      </p>
    </div>
  );
}
